import { getModule } from "vuex-module-decorators";

import PlushieStore from "@/modules/plushie/store";
import dataStore from "@/store";

import { PlushieStatusValue } from "../plushie/plushie-status.value";

export default class CustomerPreviewAvailabilityCheckerService {
  private fPlushieDataStore: PlushieStore;
  private readonly fPreviewStatuses = [
    PlushieStatusValue.CUSTOMER_PREVIEW,
    PlushieStatusValue.PPS_PREVIEW,
    PlushieStatusValue.BULK_PREVIEW,
  ];

  constructor() {
    this.fPlushieDataStore = getModule(PlushieStore, dataStore);
  }

  public async check(plushieId: string): Promise<void> {
    const plushie = await this.fPlushieDataStore.loadPlushieById({
      id: plushieId,
      useCache: false,
    });

    if (!plushie) {
      throw new Error("Plushie not found");
    }

    if (!this.fPreviewStatuses.includes(plushie.status)) {
      throw new Error("Plushie status is not customer preview");
    }
  }
}
